import { z } from "zod";

import { defaultFalseSchema, defaultTrueSchema } from "./primitives";

export const ageViewStateSchema = z.object({
  showBirthdaySection: defaultFalseSchema,
  showNeuteredSection: defaultFalseSchema,
});

export const viewStateSchema = z.object({
  checkout: z.preprocess(
    (val) => val ?? {},
    z.object({
      // Step 1 - Contact details
      hasCompletedContactDetailsOnce: defaultFalseSchema,
      isContactDetailsEditing: defaultFalseSchema,
      // Step 2 - Delivery / shipping address
      showManualEntryButton: defaultFalseSchema,
      showAddressSelect: defaultFalseSchema,
      showShippingAddressFields: defaultFalseSchema,
      hasClickedFindAddress: defaultFalseSchema,
      isDeliveryComplete: defaultFalseSchema,
      hasCompletedDeliveryOnce: defaultFalseSchema,
      hasSelectedAddressFromLookup: defaultFalseSchema,
      showShippingAddressWarning: defaultFalseSchema,
      showBillingAddressFields: defaultFalseSchema,
      billingSameAsShipping: defaultTrueSchema,
      // Step 3 - Payment
      showProcessingModal: defaultFalseSchema,
      isPaymentFormValid: defaultFalseSchema,
      shouldTriggerPayment: defaultFalseSchema,
    }),
  ),
  catParentDetails: z.preprocess(
    (val) => val ?? {},
    z.object({
      isTransitionVisible: defaultFalseSchema,
    }),
  ),
  age: z.record(z.string(), ageViewStateSchema).default({}),
});

export type TAgeViewState = z.infer<typeof ageViewStateSchema>;
export type TViewState = z.infer<typeof viewStateSchema>;
